export default {
  id: 250,
  title: 'Target #250 - Recursion',
  url: 'https://cssbattle.dev/play/250',
  colors: ['#FFFFFF', '#000000'],
  solution:
    '<p a><p b><p c><p d><p e><p f><p g><style>p[c],p[d]{left:160;width:80}p[b],p[d]{top:110;height:80}body,p[b],p[c],p[e],p[f]{background:#fff}p[f],p[g]{left:185;width:30}p[e],p[g]{top:135;height:30}p[a],p[d],p[g]{background:#000;border-radius:9in}p[a],p[b],p[c],p[d],p[e],p[f],p[g]{border-radius:9in}p{position:fixed;margin:0}p[a]{top:10;left:60;width:280;height:280}p[b]{left:70;width:260}p[c]{top:20;height:260}p[e]{left:165;width:70}p[f]{top:115;height:70',
}
